
console.log("Reach v4.2026.2");
ats = {};
ats.alerts = {};

/**
 * Escape a string for safe insertion into HTML via jQuery .html().
 * Prevents XSS when mixing user-controlled text with HTML markup.
 */
ats.escHtml = function (str) {
    return $('<span>').text(str).html();
};

/**
 * Idempotently turn a container into a drag-to-reorder list using SortableJS.
 *
 * Drop-in replacement for the legacy jQuery UI `.sortable()` used by the form
 * editor option lists, approval chains, saved searches and checklists. Accepts
 * a CSS selector, a jQuery object or a DOM element.
 *
 * Re-calling on an already-initialised element is a no-op: SortableJS
 * automatically tracks children added later, so the old jQuery UI idiom of
 * re-initialising after every append is unnecessary (and would otherwise stack
 * duplicate drag handlers).
 *
 * jQuery UI option mapping: pass `handle` as before, and use an `onEnd`
 * callback in place of the old `stop` callback. The existing reorder callbacks
 * read DOM order directly, so they don't rely on the jQuery UI event/ui args.
 *
 * @param {string|JQuery|HTMLElement} target Container element or selector
 * @param {object} [options] SortableJS options, merged over sensible defaults
 * @returns {object|null} The SortableJS instance, or null if unavailable
 */
ats.sortable = function (target, options = {}) {
    var el = typeof target === 'string'
        ? document.querySelector(target)
        : (target && target.jquery ? target[0] : target);

    if (!el || typeof window.Sortable === 'undefined') {
        return null;
    }

    if (el._atsSortable) {
        return el._atsSortable;
    }

    el._atsSortable = window.Sortable.create(el, Object.assign({
        animation: 150,
        // Mirror jQuery UI sortable's default `cancel: ":input,button"` so a
        // drag never starts from a form control, button, link, select2 box or
        // Bootstrap dropdown inside a row. preventOnFilter:false keeps those
        // controls fully interactive (focus, open dropdown, click).
        filter: 'input, textarea, select, button, a, .select2, .select2-container, .dropdown',
        preventOnFilter: false,
    }, options));

    return el._atsSortable;
};

$(document).ready(function () {
    ats.uiElements();

    $(document).on('click', '.fixed-action-btn', function (e) {
        ats.toggleFABMenu($(this));
        if ($(this).is("a")) { e.preventDefault(); }
        return false;
    });

    /*match height of sister elements
    $('.equalHeight').matchHeight();
    $('.equalHeightChild').matchHeight();*/

    ats.formElements();

    $('#savedSearch').on('change', function (e) {
        $(location).attr('href', $(this).val());
    });

    /* Close Info Panel */
    $(".close-modal-info").on('click', function (e) {
        e.preventDefault();
        $('#infoPanel').modal('hide');
    });

    /* prevent propogation of # links */
    $('a[href="#"]').on('click', function (e) {
        e.preventDefault();
    });

    /* info modal jump-to section scroll */
    $(document).on('click', '.panel_scrollto', function (e) {
        var $element = $('#' + $(this).data('scrollto'));
        var $container = $element.parent().parent();
        var offset = $container.scrollTop() + ($element.offset().top - $container.offset().top) - 15;

        console.log($container);
        console.log(offset);

        $container.animate({
            scrollTop: offset
        }, 500);
    });

    $(document).on('click', '.nav-item', function (e) {
        if (!$(this).hasClass('open') && $(this).parent('.sidebar').hasClass('toggled') == false) {
            $('.nav-item').removeClass('open');
            $(this).addClass('open');
        } else {
            $(this).removeClass('open');
        }
    });

});
/* END DOC RDY */

ats.removeElementFromCollection = function (collection, key) {
    // if the collection is an array
    if (collection instanceof Array) {
        if (jQuery.inArray(key, collection) != -1) {
            collection.splice(jQuery.inArray(key, collection), 1);
        }
    }
    // it's an object
    else if (collection.hasOwnProperty(key)) {
        delete collection[key];
    }

    return collection;
};

ats.route = function (token, name, qs = null) {
    return new Promise((resolve, reject) => {
        var formData = {};
        formData._token = token;
        formData.qs = qs;
        formData.name = name;
        $.ajax({
            type: "POST",
            url: "/get-url",
            data: formData,
            success: function (response) {
                resolve(response);
            },
            error: function (jqXHR, textStatus) {
                reject(textStatus);
            }
        })
    })
};

ats.routeContent = function (token, name, qs = null) {
    return new Promise((resolve, reject) => {
        var formData = {};
        formData._token = token;
        formData.qs = qs;
        formData.name = name;
        $.ajax({
            type: "POST",
            url: "/get-content",
            data: formData,
            success: function (response) {
                resolve(response);
            },
            error: function (jqXHR, textStatus) {
                reject(textStatus);
            }
        })
    })
};

ats.editForm = function (application_id, form_id) {
    $('#formModalBody').load(`/candidate/form/${application_id}/${form_id}`, function (data) {
        $('#editFormModal').modal('show');
    });

}

ats.multiForm = function (app_ids = null, initial_form = '', standalone = 0, stageId = null, instance = null) {
    if (app_ids == null) {
        app_ids = batchActionCandidates;
    }

    var $popoutForm = $('#multiFormPopoutForm');
    var $popoutButton = $('#multiFormPopoutButton');
    if ($popoutForm.length) {
        var candidateIdsValue = Array.isArray(app_ids) ? JSON.stringify(app_ids) : JSON.stringify([]);
        var initialFormValue = (typeof initial_form === 'undefined' || initial_form === null) ? '' : initial_form;
        var standaloneValue = (typeof standalone === 'undefined' || standalone === null || standalone === '') ? 0 : standalone;
        var stageIdValue = (stageId === null || stageId === 'null' || typeof stageId === 'undefined') ? 'null' : stageId;
        var instanceValue = (instance === null || instance === 'null' || typeof instance === 'undefined') ? '' : instance;

        $('#multiFormPopoutCandidateIds').val(candidateIdsValue);
        $('#multiFormPopoutInitialForm').val(initialFormValue);
        $('#multiFormPopoutStandalone').val(standaloneValue);
        $('#multiFormPopoutStageId').val(stageIdValue);
        $('#multiFormPopoutInstance').val(instanceValue);
        if ($popoutButton.length) {
            $popoutButton.prop('disabled', true);
        }
    }

    var formData = new FormData();
    formData.append('_token', $("input[name=_token]").val());
    formData.append('candidate_ids', JSON.stringify(app_ids));
    formData.append('initial_form', initial_form);
    formData.append('standalone', standalone);
    formData.append('stageId', stageId);
    formData.append('instance', instance);

    $.ajax({
        method: "POST",
        url: '/candidate/multiform',
        processData: false,
        contentType: false,
        data: formData,
        success: function (response) {
            $('#multiFormModalBody').html(response);
            if ($popoutButton.length) {
                $popoutButton.prop('disabled', false);
            }
            $('#multiFormModal').modal('show');
        },
        error: function (xhr, ajaxOptions, thrownError) {
            console.log(xhr);
            if (typeof xhr.responseJSON != 'undefined') {
                if (typeof xhr.responseJSON.message != 'undefined') {
                    var msg = xhr.responseJSON.message;
                } else {
                    var msg = xhr.status + ':' + thrownError;
                }
            } else {
                var msg = xhr.status + ':' + thrownError;
            }
            ats.alerts.notice('Error Processing Form', "Please retry or contact support with this information:<br />" + msg + '.<br />' + xhr.status + ':' + thrownError + '/' + user_id + '/' + type_id + '@' + Math.floor(Date.now() / 1000), 'error');
            if ($popoutButton.length) {
                $popoutButton.prop('disabled', true);
            }
        }
    });

}

ats.saveForm = function (application_id, form_id, save_for_later = false, callback = null, standalone = 0, instance = null) {
    const $form = $("#form_form");
    $form.off('submit').on('submit', function (e) {

        e.preventDefault();
        var formData = new FormData(this);
        formData.append('save_for_later', save_for_later);
        formData.append('standalone', standalone);
        formData.append('instance', instance);

        var performAjax = function () {
            // saveForm()
            //url: `/candidate/form/${application_id}/${form_id}`,
            $.ajax({
                url: "/candidate/form/" + application_id + "/" + form_id,
                type: 'POST',
                data: formData,
                success: function (data) {
                    if (data != '') {
                        if (data == '_close') {
                            window.location.hash = 'app_' + application_id;
                            window.location.reload();
                            return;
                        }
                        if ($('#editor_form').length > 0) {
                            $('#editor_form').html(data);
                        } else {
                            $('#formModalBody').html(data);
                        }
                        setTimeout(function () { ats.formElements(); }, 50);
                    } else {
                        //we're done
                        //$('#editFormModal').modal('hide');
                        if (callback != null) {
                            callback();
                        } else {
                            window.location.hash = 'app_' + application_id;
                            window.location.reload();
                        }

                    }
                    $('#editFormModal').animate({ scrollTop: 0 }, 200);
                },
                error: function (xhr, ajaxOptions, thrownError) {
                    console.log(xhr);
                    ats.alerts.notice('Error Processing Form', xhr.status + ':' + thrownError + '.<br />Please retry or contact support with this information:<br />' + xhr.status + '/' + application_id + "/" + form_id + '/' + user_id + '/' + type_id + '@' + Math.floor(Date.now() / 1000), 'error');
                    $("#form_action_buttons button").prop('disabled', false);
                },
                cache: false,
                contentType: false,
                processData: false
            });
        };

        // ReachSign: signable forms must capture a signature before the answers commit.
        // Save-for-later bypasses signing (progress can be saved without a signature).
        // Signature capture is now an inline form section; the submit button is disabled
        // until the panel reports ready, so this guard is just belt-and-braces.
        if (window.atsFormSignable && !save_for_later && typeof window.atsSignatureCapture !== 'undefined') {
            const payload = window.atsSignatureCapture.getPayload();
            if (!payload) {
                ats.alerts.toast('Please complete your signature, declaration and name before submitting.', 'warning');
                $("#form_action_buttons button").prop('disabled', false);
                return;
            }
            formData.append('_signature_image', payload.signature_image);
            formData.append('_signature_confirmed_name', payload.confirmed_name);
            formData.append('_signature_confirmed_initials', payload.confirmed_initials);
            formData.append('_signature_declaration_accepted', payload.declaration_accepted ? '1' : '0');
        }

        performAjax();
    });
    $form.trigger('submit');
}

ats.showOnHover = function (hover_element, show_element = '.show-on-hover') {
    $('body').on({
        'mouseover': function () {
            $(this).find(show_element).fadeTo(100, 1);
        },
        'mouseleave': function () {
            $(this).find(show_element).fadeTo(0, 0);
        }
    }, hover_element);
}

ats.uiElementsDestroy = function () {
    $('[data-toggle="popover"], .popover').popover('dispose');
    $('[data-toggle="dropdown"], .dropdown-toggle').dropdown('dispose');
    $('[data-toggle="tooltip"], .tip').tooltip('dispose');
}

ats.uiElementsCreate = function () {
    if (tooltips_enabled) {
        /*$('[data-toggle="tooltip"], .tip').tooltip();*/
        $('[data-toggle="tooltip"], .tip').each((_i, e) => {
            $(e).tooltip();
        });
        $('[data-toggle="tooltip"], .tip').on('click', function () {
            $('[data-toggle="tooltip"], .tip').tooltip("hide");
        });
    } else {
        $('[data-toggle="tooltip"], .tip').tooltip('disable');
        $('.tip-force').tooltip();
    }

    /*$('[data-toggle="popover"], .popover').popover();*/
    $('[data-toggle="popover"], .popover').each((_i, e) => {
        $(e).popover();
    });

    /*$('[data-toggle="dropdown"], .dropdown-toggle').popover();*/
    $('[data-toggle="dropdown"], .dropdown-toggle').each((_i, e) => {
        $(e).dropdown();
    });
}

ats.uiElements = function (report = false) {
    ats.uiElementsDestroy();
    ats.uiElementsCreate();
    if (report !== false) {
        console.log('reset ui component js');
    }
};

ats.formElementsDestroy = function () {
    /* destroy to prevent duplicates */
    const $select2ToDestroy = $('select.select2.select2-hidden-accessible:not(.no-destroy)');
    if ($select2ToDestroy.length) {
        $select2ToDestroy.select2('destroy');
    }
    $(".component_datepicker, .component_future_datepicker, .component_past_datepicker, .component_month_datepicker").datepicker("destroy");
}

ats.formElementsCreate = function () {
    /* init custom elements */
    $('select.select2:not(.select2-hidden-accessible),select.selectpicker:not(.select2-hidden-accessible)').each((_i, e) => {
        var $e = $(e);
        var $placeholder = 'Select an option';
        if ($e.data('placeholder')) {
            $placeholder = $e.data('placeholder');
        } else if ($e.attr('placeholder') != "" && typeof $e.attr('placeholder') != "undefined") {
            $placeholder = $e.attr('placeholder');
        }
        var placeholderConfig = $e.prop('multiple')
            ? $placeholder
            : { id: 'PLACEHOLDER_VALUE', text: $placeholder };
        $e.select2({
            minimumResultsForSearch: 10,
            theme: 'bootstrap4',
            width: '100%',
            dropdownParent: $e.parent(),
            placeholder: placeholderConfig
        });
    });
    /*$('.select2,.selectpicker').select2({
        placeholder: {
            id: 'PLACEHOLDER_VALUE', // the value of the option
            text: 'Select an option'
        },
        minimumResultsForSearch: 10,
        theme: 'bootstrap4',
        width: '100%'
    });*/
    $('select.select2-tags:not(.select2-hidden-accessible)').each((_i, e) => {
        var $e = $(e);
        var $placeholder = 'Click to select or type a tag';
        if ($e.attr('placeholder') != "" && typeof $e.attr('placeholder') != "undefined") {
            $placeholder = $e.attr('placeholder');
        }
        $e.select2({
            theme: 'bootstrap4',
            width: '100%',
            tags: true,
            tokenSeparators: [','],
            dropdownParent: $e.parent(),
            placeholder: $placeholder
        });
    });
    /*$(".select2-tags").select2({
        theme: 'bootstrap4',
        width: '100%',
        tags: true,
        tokenSeparators: [','],
        placeholder: 'Click to select or type a tag'
    });*/
    $('select.select2-optgroup:not(.select2-hidden-accessible)').each((_i, e) => {
        var $e = $(e);
        var $placeholder = 'Select an option';
        if ($e.attr('placeholder') != "" && typeof $e.attr('placeholder') != "undefined") {
            $placeholder = $e.attr('placeholder');
        }
        $e.select2({
            minimumResultsForSearch: 10,
            theme: 'bootstrap4',
            width: '100%',
            matcher: ats.modelMatcher,
            dropdownParent: $e.parent(),
            placeholder: {
                id: 'PLACEHOLDER_VALUE', // the value of the option
                text: $placeholder
            }
        });
    });

    /*$('.select2-optgroup').select2({
        placeholder: {
            id: 'PLACEHOLDER_VALUE', // the value of the option
            text: 'Select an option'
        },
        minimumResultsForSearch: 10,
        theme: 'bootstrap4',
        width: '100%',
        matcher: ats.modelMatcher
    });*/

    $(document).on('select2:open', () => {
        let allFound = document.querySelectorAll('.select2-container--open .select2-search__field');
        $(this).one('mouseup', () => {
            setTimeout(() => {
                allFound[allFound.length - 1].focus();
            }, 0);
        });
    });
    $('.component_datepicker').datepicker({ format: 'dd/mm/yyyy', clearBtn: true });
    $('.component_future_datepicker').datepicker({ format: 'dd/mm/yyyy', clearBtn: true, startDate: "now", autoclose: true });
    $('.component_past_datepicker').datepicker({ format: 'dd/mm/yyyy', clearBtn: true, endDate: "now", autoclose: true });
    $(".component_month_datepicker").datepicker({
        format: "M yyyy",
        startView: "months",
        minViewMode: "months",
        clearBtn: true,
        endDate: "now",
        autoclose: true
    });
}
ats.formElements = function (report = false) {
    ats.formElementsDestroy();
    ats.formElementsCreate();
    if (report !== false) {
        console.log('reset form component js');
    }
};

ats.destroyUIJs = function () {
    ats.formElementsDestroy();
    ats.uiElementsDestroy();
    console.log('destroyed ui components');
}

ats.createUIJs = function () {
    ats.formElementsCreate();
    ats.uiElementsCreate();
    console.log('created ui components');
}

ats.resetUIJs = function () {
    ats.uiElements();
    ats.formElements();
    console.log('reset ui components');
}

ats.initializeSwitchery = function (selector = '.js-switch', options = {}) {
    ats.destroySwitchery(selector);
    var elems = document.querySelectorAll(selector);
    elems.forEach(function (html) {
        if (!html.switchery) { // Avoid reinitializing if already done
            html.switchery = new Switchery(html, options);
        }
    });
}

ats.destroySwitchery = function (selector = '.js-switch',) {
    var elems = document.querySelectorAll(selector);
    elems.forEach(function (html) {
        if (html.switchery) {
            // Remove the Switchery switch element
            if (html.switchery.element.parentNode) {
                html.switchery.element.parentNode.removeChild(html.switchery.element.nextSibling);
            }
            delete html.switchery; // Remove reference to the Switchery instance
        }
    });
}

/* copy to clipboard */
ats.copyToClipboard = function (textContent, copyText = "Copied to clipboard") {
    var text = textContent === null || textContent === undefined ? '' : String(textContent);

    /* The fallback uses a textarea, not an input: assigning multi-line text to an
       <input> strips the newlines, which flattens copied blocks onto one line.
       Returns whether the copy actually happened, so we never claim success we
       can't confirm. */
    var fallbackCopy = function () {
        var copied = false;
        try {
            var area = document.createElement('textarea');
            area.value = text;
            area.setAttribute('readonly', '');
            /* Keep it off-screen but selectable — display:none/hidden breaks execCommand. */
            area.style.position = 'fixed';
            area.style.top = '0';
            area.style.left = '0';
            area.style.opacity = '0';
            document.body.appendChild(area);
            area.select();
            copied = document.execCommand('copy', false);
            area.remove();
        } catch (e) {
            copied = false;
        }
        return copied;
    };

    var report = function (copied) {
        if (copied) {
            ats.alerts.toast(copyText);
        } else {
            ats.alerts.toast("Couldn't copy automatically — please select the text and copy it manually.");
        }
    };

    /* Report only what actually happened — the toast used to fire unconditionally,
       so a blocked copy still said "Copied to clipboard". */
    if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(text).then(function () {
            report(true);
        }).catch(function () {
            /* execCommand needs transient user activation, which may have lapsed
               by the time this rejection handler runs — hence reporting whatever
               it returns rather than assuming it worked. */
            report(fallbackCopy());
        });
        return;
    }

    report(fallbackCopy());
}

ats.arrayRemove = function (arr, value) {
    return arr.filter(function (ele) {
        return ele != value;
    });
}

/* Candidate listing and email editor routines */
batchActionCandidates = [];
$('.batchActionCheck').on('change', evt => {
    var candidate_id = $(evt.target).val();
    if ($(evt.target).is(':checked')) {
        if (!batchActionCandidates.includes(candidate_id)) {
            batchActionCandidates.push(candidate_id);
        }
    } else {
        batchActionCandidates = ats.arrayRemove(batchActionCandidates, candidate_id);
    }

    $('#selectionCount').html(batchActionCandidates.length);

    if (batchActionCandidates.length == 0) {
        $("#batchDropContainer,#batchDropContainerCount").addClass('d-none');
    } else {
        $("#batchDropContainer,#batchDropContainerCount").removeClass('d-none');
    }
});

ats.emailIsEdited = false;
ats.useTemplate = false;
ats.isEnhancedTemplate = false;
ats.template_selected = '';

ats.email = function () {
    $('#emailModalTitle').html('Send Email Template');
    $('#emailCancelButton').on('click', ats.closeEmailModal);
    ats.loadEmailTemplates(true);
}

ats.emailComposeSingle = function (showModal, candidate_id) {
    $("#chk_" + candidate_id).prop("checked", true).trigger('change');
    ats.emailCompose(showModal);
}

//send to all in dataset sends the email to every candidate for the current search and not just the first 50 on screen
ats.sendToAllInDataSet = false;
ats.emailCompose = function (showModal = false, useTemplateOpt = false, sendToAllInDataSet = false) {
    if (batchActionCandidates.length == 0 && ats.all_app_ids.length == 0) {
        ats.alerts.notice('Missing Requirements', 'You must select at least one candidate to email', 'error');
    } else {
        if (sendToAllInDataSet) {
            ats.sendToAllInDataSet = true;
        } else {
            ats.sendToAllInDataSet = false;
        }
        $('#emailCancelButton').on('click', ats.closeEmailModal);
        ats.emailIsEdited = false;
        if (useTemplateOpt == true) {
            id = ats.template_selected;
            ats.useTemplate = true;
        } else {
            id = '';
            ats.useTemplate = false;
        }

        $('#emailModalTitle').html('Compose New Email');
        $.get('/candidate/email/compose/' + id, function (result) {
            $('#emailModalBody').html(result);
            $('#recipient').val('[email]').select2({ theme: 'bootstrap4', 'width': '100%' });
            if (showModal == true) {
                $('#emailModal').modal({ focus: false, show: true });

                if (sendToAllInDataSet == true) {
                    $('#recipient_count').html(ats.all_app_ids.length);
                } else {
                    $('#recipient_count').html(batchActionCandidates.length);
                }

            }
        });
    }

}

ats.emailSend = function () {

    if (
        (
            current_template_selection != ""
            || (!ats.useTemplate && (text_editor.getContent().length > 0 && $('#subject').val().length > 0))
        )
        && (batchActionCandidates.length > 0 || ats.all_app_ids.length > 0)
    ) {
        var formData = new FormData();
        if (ats.sendToAllInDataSet == false) {
            formData.append('candidates', batchActionCandidates);
        } else {
            formData.append('candidates', ats.all_app_ids);
        }

        formData.append('_token', $("input[name=_token]").val());
        formData.append('recipient', $('#recipient').val());
        // if(ats.isEnhancedTemplate) {
        //     formData.append('from',$('#from').val());
        // }else{
        //     formData.append('from',null);
        // }

        formData.append("from", $("#from").val());

        formData.append('template', current_template_selection);
        if (ats.emailIsEdited || !ats.useTemplate) {
            ats.emailIsEdited = true; //whether edited or bespoke set flag to true so controller knows to make a new template
            if (ats.isEnhancedTemplate == false) {
                formData.append('content', text_editor.getContent());
            } else {
                var html = $('#enhancedTemplatePreview').contents().find('html').html();
                formData.append('content', '<html>' + html + '</html>');
            }

            formData.append('subject', $('#subject').val());
            formData.append('attachments', $("input[name='attachments[]']").map(function () { return $(this).val(); }).get());
            formData.append('tag_attachments', $("input[name='tag_attachments[]']").map(function () { return $(this).val(); }).get());
        }
        formData.append('emailIsEdited', ats.emailIsEdited);

        $.ajax({
            method: "POST",
            url: '/candidate/email/send',
            processData: false,
            contentType: false,
            data: formData,
        }).done(function (result) {
            var json = JSON.parse(result);
            //close editor on success
            if (json.status == 0) {
                ats.closeEmailModal();
                ats.alerts.response('Success', 'Yours email(s) have been sent', 'success');
                batchActionCandidates = [];
                //window.location.href=window.location.href;
            } else {
                ats.alerts.notice('Error', json.status, 'error');
            }
            //$('#templates_container').html(result);
        });
    } else {
        ats.alerts.notice('Missing Requirements', 'You must select a template to send, or populate the subject and content fields', 'error');
    }
}

ats.removeFile = function (application_id, form_id, file_id) {
    var ele = $('#editor_form').length > 0 ? '#editor_form' : '#formModalBody';
    $.ajax({
        url: '/candidate/file/remove/' + application_id + '/' + form_id + '/' + file_id,
        type: 'POST',
        data: $('#form_form').serialize(),
        success: function (html) { $(ele).html(html); }
    });
}

ats.confirmLoad = function () {
    if (is_reverting) {
        is_reverting = false;
        return;
    }
    if (ats.emailIsEdited) {
        ats.alerts.confirm('Discard Changes?', 'You have made changes to your email. Would you like to discard them?', 'question', ats.loadEmailTemplates, true,
            function () { is_reverting = true; $('#recipient').val(currentRecipient).change(); });
    } else {
        ats.loadEmailTemplates(true);
        currentRecipient = $('#recipient').val();
    }
}

ats.confirmEditorLoad = function (id) {
    if (ats.emailIsEdited) {
        ats.alerts.confirm('Discard Changes?', 'You have made changes to your email. Would you like to discard them?', 'question', ats.loadEmailTemplate, id, function () {
            $('#t_' + current_template_selection).removeClass('bg-primary text-white');
            current_template_selection = '';
        });
    } else {
        ats.loadEmailTemplate(id);

    }
}

ats.loadEmailTemplates = function (clearEditor = false) {

    var formData = new FormData();
    formData.append('candidates', JSON.stringify(batchActionCandidates));
    formData.append('_token', $("input[name=_token]").val());

    if ($('#template_search').val() != '') {
        formData.append('template_search', $('#template_search').val());
    }
    formData.append('recipient', $('#recipient').val());

    $.ajax({
        method: "POST",
        url: '/candidate/email/templates',
        processData: false,
        contentType: false,
        data: formData,
    }).done(function (result) {
        $('#templates_container').html(result);
    });
    if (clearEditor) {
        text_editor.setContent('');
        $('#subject').val('');
        ats.emailIsEdited = false;
    }
}

ats.loadEmailTemplate = function (id) {
    ats.loadEmailTemplateAttachments(id);
    $.get('/candidate/load/template/' + id, function (response) {

        var json = JSON.parse(response);
        var templateFrom = json.from || '';
        $('#from').val(templateFrom).trigger('change.select2');

        if (json.type == 'Enhanced') {
            $('#enhancedTemplatePreview').contents().find('body').html(json.body);
            $('#standardTemplatePreview').addClass('d-none');
            $('#enhancedTemplatePreview').removeClass('d-none');
            ats.emailIsEdited = true;
            ats.isEnhancedTemplate = true;
        } else {
            text_editor.setContent(json.body); // was ck_editor.setData(json.body)
            $('#standardTemplatePreview').removeClass('d-none');
            $('#enhancedTemplatePreview').addClass('d-none');
            ats.emailIsEdited = false;
            ats.isEnhancedTemplate = false;
            ats.useTemplate = true;
        }
        $('#subject').val(json.subject);
        $('#recipient').val(json.recipient.split("|")).select2({ theme: 'bootstrap4', 'width': '100%' });

    });
}

ats.loadEmailTemplateAttachments = function (id) {
    $('li.attachment').remove();
    $.get('/candidate/load/template/attachments/' + id, function (response) {
        var json = JSON.parse(response);
        $('#attachment_count').html(json.normal.length + json.tags.length);
        if (json.normal.length != 0) {
            $('#no_attachments_message').addClass('d-none');
            for (item in json.normal) {
                $('#files_list').append(ats.fab('attachment_row', { id: json.normal[item].id, name: json.normal[item].name.replace(/_/g, ' '), type: json.normal[item].type, size: json.normal[item].size, uploaded: json.normal[item].uploaded }));
            }
        }

        if (json.tags.length != 0) {
            $('#no_attachments_message').addClass('d-none');
            for (item in json.tags) {
                $('#files_list').append(ats.fab('tag_attachment_row', { id: json.tags[item].id, name: json.tags[item].name.replace(/_/g, ' '), type: json.tags[item].type, size: json.tags[item].size, uploaded: json.tags[item].uploaded, tag: json.tags[item].tag }));
            }
        }

    });
}

ats.loadEmailTemplatePreview = function (id) {
    ats.template_selected = id;
    $.get('/library/emails/preview/' + id, function (response) {
        $('#template_buttons').show(0);
        $('#template_preview').html(response);
    });
}

ats.closeEmailModal = function () {
    $('#emailModal').modal('hide');
    ats.emailIsEdited = false;
    ats.useTemplate = false;
    ats.isEnhancedTemplate = false;
}

$('#emailModal').on('hidden.bs.modal', function () {
    if (typeof tinymce !== 'undefined' && tinymce.get('editor')) {
        tinymce.remove('#editor');
    }
});

$('#emailModal').on('shown.bs.modal', function () {
    var container = $('#recipient_container');
    if (ats.sendToAllInDataSet == true) {
        $('#recipient_count').html(ats.all_app_ids.length);
    } else {
        $('#recipient_count').html(batchActionCandidates.length);
    }
    //$('#recipient_count').html(batchActionCandidates.length);
    var formData = new FormData();
    formData.append('candidates', JSON.stringify(batchActionCandidates));
    formData.append('_token', $("input[name=_token]").val());

    $.ajax({
        method: "POST",
        url: '/candidate/email/recipients',
        processData: false,
        contentType: false,
        data: formData,
    }).done(function (result) {
        container.html(result);
    });

    /* for(item in batchActionCandidates){
        container.append('<li class="list-group-item">' + batchActionCandidates[item] + '</li>');
    } */
});

/* end candidate list and email routines */

ats.modelMatcher = function (params, data) {
    data.parentText = data.parentText || "";

    // Always return the object if there is nothing to compare
    if ($.trim(params.term) === '') {
        return data;
    }

    // Do a recursive check for options with children
    if (data.children && data.children.length > 0) {
        // Clone the data object if there are children
        // This is required as we modify the object to remove any non-matches
        var match = $.extend(true, {}, data);

        // Check each child of the option
        for (var c = data.children.length - 1; c >= 0; c--) {
            var child = data.children[c];
            child.parentText += data.parentText + " " + data.text;

            var matches = ats.modelMatcher(params, child);

            // If there wasn't a match, remove the object in the array
            if (matches == null) {
                match.children.splice(c, 1);
            }
        }

        // If any children matched, return the new object
        if (match.children.length > 0) {
            return match;
        }

        // If there were no matching children, check just the plain object
        return ats.modelMatcher(params, match);
    }

    // If the typed-in term matches the text of this term, or the text from any
    // parent term, then it's a match.
    var original = (data.parentText + ' ' + data.text).toUpperCase();
    var term = params.term.toUpperCase();


    // Check if the text contains the term
    if (original.indexOf(term) > -1) {
        return data;
    }

    // If it doesn't contain the term, don't return anything
    return null;
}

ats.toggleFABMenu = function (btn) {

    $this = btn;
    if ($this.hasClass('active') === false) {
        $this.addClass('active');
        $this.find('i.fa-plus').addClass('fa-rotate-45');
        $this.find('ul li .btn-floating').velocity({
            scaleY: ".4",
            scaleX: ".4",
            translateY: "40px"
        }, {
            duration: 0
        });

        var time = 0;
        $($this.find('ul .btn-floating').get().reverse()).each(function () {
            $(this).velocity({
                opacity: "1",
                scaleX: "1",
                scaleY: "1",
                translateY: "0"
            }, {
                duration: 80,
                delay: time
            });
            time += 40;
        });
    } else {
        $this.removeClass('active');
        $this.find('i.fa-plus').removeClass('fa-rotate-45');
        var time = 0;
        $this.find('ul .btn-floating').velocity("stop", true);
        $this.find('ul .btn-floating').velocity({
            opacity: "0",
            scaleX: ".4",
            scaleY: ".4",
            translateY: "40px"
        }, {
            duration: 80
        });
    }
}

ats.like = function (id) {
    var icon = $('#like_' + id);
    var label = $('#like_label_' + id);
    if (icon.hasClass('d-none')) {
        // not currently liked
        $.get('/candidate/like/' + id);
        label.html('Unlike');
    } else {
        $.get('/candidate/unlike/' + id);
        label.html('Like');
    }
    icon.toggleClass('d-none');

}

/**
 * Normalise a time-of-day string to canonical hh:mm (24 hour).
 * Accepts '5pm', '17.30', '9:30', '1730', ' 12:00 '; returns null when the
 * value cannot be interpreted. Mirrors normaliseClosingTime() in
 * app/Helpers/vacancy.php - keep the two in step.
 */
ats.normaliseTime = function (value) {
    var candidate = String(value == null ? '' : value).trim().toLowerCase().replace(/\./g, ':');
    if (candidate === '') {
        return null;
    }

    var meridiem = null;
    var meridiemMatch = candidate.match(/^(.*?)\s*(am|pm)$/);
    if (meridiemMatch) {
        candidate = meridiemMatch[1].trim();
        meridiem = meridiemMatch[2];
    }

    if (/^\d{3,4}$/.test(candidate)) {
        candidate = candidate.slice(0, -2) + ':' + candidate.slice(-2);
    }

    var parts = candidate.match(/^(\d{1,2})(?::(\d{1,2}))?$/);
    if (!parts) {
        return null;
    }

    var hours = parseInt(parts[1], 10);
    var minutes = parts[2] === undefined ? 0 : parseInt(parts[2], 10);

    if (meridiem === 'pm' && hours >= 1 && hours <= 11) {
        hours += 12;
    }
    if (meridiem === 'am' && hours === 12) {
        hours = 0;
    }

    if (hours > 23 || minutes > 59) {
        return null;
    }

    return ('0' + hours).slice(-2) + ':' + ('0' + minutes).slice(-2);
};

ats.regexValidate = function (value, type = 'required') {
    switch (type) {
        case "required":
            var regex = /^\s*$/;
            break;
        case "date":
            /*DOB: dd/mm/yyyy*/
            var regex = /^(?:(?:31(\/)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/)(?:0?[1,3-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/;
            break;
        case "time":
            /*Time: hh:mm*/
            var regex = /^(?:[01][0-9]|2[0-3]):[0-5][0-9]$/;
            break;
        case "alphanumeric":
            var regex = /^[a-zA-Z0-9]*$/;
            break;
        case "text":
            var regex = /^[a-zA-Z]*$/;
            break;
        case "numeric":
            var regex = /^[0-9]*$/;
            break;
        case "phone":
            var regex = /^((\+44\s?|0044\s?)?[0123456789]\d{3}|\(?0[0123456789]\d{3}\)?)\s?\d{3}\s?\d{3}$/;
            break;
        case "email":
            var regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            break;
    }

    if (!regex.test(value)) {
        return false;
    } else {
        return true;
    }
}

toastr.options = {
    "closeButton": true,
    "debug": false,
    "escapeHtml": true,
    "newestOnTop": true,
    "progressBar": false,
    "positionClass": "toast-top-right",
    "preventDuplicates": false,
    "onclick": null,
    "showDuration": "300",
    "hideDuration": "1000",
    "timeOut": "300",
    "extendedTimeOut": "1000",
    "showEasing": "swing",
    "hideEasing": "linear",
    "showMethod": "fadeIn",
    "hideMethod": "fadeOut",
    "tapToDismiss": true
};

ats.alerts.toastr = function (type, msg, title = false, options = {}) {
    switch (type) {
        case "info":
            toastr.info(msg, title, options);
            break;
        case "success":
            toastr.success(msg, title, options);
            break;
        case "warning":
            toastr.warning(msg, title, options);
            break;
        case "error":
            toastr.error(msg, title, options);
            break;
    }
};

ats.alerts.confirmDelete = function (path, name) {
    Swal.fire({
        title: 'Confirm Deletion',
        text: "Are you sure you want to delete " + name + '?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        confirmButtonText: 'Confirm'
    }).then((result) => {
        if (result.value) {
            var csrf = document.querySelector("meta[name=csrf-token]").getAttribute("content");
            var form = document.createElement('form');
            form.method = 'POST';
            form.action = path;
            var tokenInput = document.createElement('input');
            tokenInput.type = 'hidden';
            tokenInput.name = '_token';
            tokenInput.value = csrf;
            form.appendChild(tokenInput);
            document.body.appendChild(form);
            form.submit();
        }
    });
    return false;
};

ats.alerts.confirm = function (title, text, iconType = 'question', action, data = null, cancelAction = null, cancelData = null) {
    Swal.fire({
        title: title,
        text: text,
        icon: iconType,
        showCancelButton: true,
        confirmButtonColor: '#d33',
        confirmButtonText: 'Yes'
    }).then((result) => {
        if (result.value) {
            if (typeof action !== "undefined") {
                action(data);
            }
        } else {
            if (typeof cancelAction !== "undefined") {
                cancelAction(cancelData);
            }
        }
    });
    return false;
};

ats.alerts.confirmDisable = function (path, name) {
    Swal.fire({
        title: 'Confirm Deactivate',
        text: "Are you sure you want to deactivate " + name + '?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        confirmButtonText: 'Confirm'
    }).then((result) => {
        if (result.value) {
            var csrf = document.querySelector("meta[name=csrf-token]").getAttribute("content");
            var form = document.createElement('form');
            form.method = 'POST';
            form.action = path;
            var tokenInput = document.createElement('input');
            tokenInput.type = 'hidden';
            tokenInput.name = '_token';
            tokenInput.value = csrf;
            form.appendChild(tokenInput);
            document.body.appendChild(form);
            form.submit();
        }
    });
    return false;
};

ats.alerts.confirmEnable = function (path, name) {
    Swal.fire({
        title: 'Confirm Enabling',
        text: "Are you sure you want to activate " + name + '?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        confirmButtonText: 'Confirm'
    }).then((result) => {
        if (result.value) {
            $(location).prop('href', path);
        }
    });
    return false;
};

ats.alerts.confirmRedirect = function (title, text, path, iconType = 'info', confirmButtonText = 'Refresh') {
    Swal.fire({
        title: title,
        text: text,
        icon: iconType,
        showCancelButton: true,
        confirmButtonColor: '#3fc2ee',
        confirmButtonText: confirmButtonText
    }).then((result) => {
        if (result.value) {
            $(location).prop('href', path);
        }
    });
    return false;
};

ats.alerts.confirmSend = function (title, text, path, iconType = 'info') {
    Swal.fire({
        title: title,
        text: text,
        icon: iconType,
        showCancelButton: true,
        confirmButtonColor: '#3fc2ee',
        confirmButtonText: 'Send'
    }).then((result) => {
        if (result.value) {
            $(location).prop('href', path);
        }
    });
    return false;
};

ats.alerts.confirmPost = function (title, text, path, redirect, iconType = 'info') {
    if (iconType == 'error' || iconType == 'danger' || iconType == 'warning') {
        var btnColor = '#d33';
    } else {
        var btnColor = '#3fc2ee';
    }
    Swal.fire({
        title: title,
        text: text,
        icon: iconType,
        showCancelButton: true,
        confirmButtonColor: btnColor,
        confirmButtonText: 'Confirm'
    }).then((result) => {
        if (result.value) {
            var csrf = document.querySelector("meta[name=csrf-token]").getAttribute("content");
            $.post(path, { _token: csrf }, function (response) {
                $(location).prop('href', redirect);
            });
        }
    });
    return false;
};

ats.alerts.notice = function (title, text, iconType = 'info', buttonColor = '#3fc2ee') {
    Swal.fire({
        title: title,
        html: text,
        icon: iconType,
        showCancelButton: false,
        confirmButtonColor: buttonColor,
        confirmButtonText: 'OK'
    });
    return false;
};

ats.alerts.response = function (title, text, iconType = "success") {
    Swal.fire({
        title: title,
        html: text,
        icon: iconType,
        showCancelButton: false,
        confirmButtonColor: '#d33',
        confirmButtonText: 'OK',
        timer: 6000
    });
    return false;
};

ats.alerts.toast = function (message, iconType = "success", timer = 3000) {
    Swal.fire({
        html: message,
        icon: iconType,
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: timer
    });
}

ats.filters = {
    clear: function (name) {
        $('#' + name).prop("disabled", "disabled");
        $('#filter_form').submit();
    },
    submit: function () {
        if ($('#_search').val() == '') $('#_search').prop("disabled", "disabled")
        $('#filter_form select').each(function () {
            if ($(this).val() == '') $(this).prop("disabled", "disabled");
        })
        $('#filter_form').submit();
    }
};

ats.search = {
    save: function (token, name) {
        Swal.fire({
            title: 'Please enter a name',
            input: 'text',
            inputValue: name,
            showCancelButton: true,
            inputValidator: (value) => {
                return !value && 'You need to select a name'
            },
            showCancelButton: true,
            confirmButtonText: "Save",
            cancelButtonText: "Cancel"
        }).then(function (result) {
            if (result.value) {
                var data = {};
                data._token = token;
                data.url = window.location.href;
                data.name = result.value;
                $.ajax({
                    url: "/search/save",
                    type: "POST",
                    contentType: "application/json",
                    data: JSON.stringify(data),
                    cache: false,
                    success: function (response) {
                        Swal.fire(
                            "Success!",
                            response,
                            "success"
                        );
                        $("#savedSearchDropdown").append('<a class="dropdown-item" href="javascript:void(0);" onclick="window.location.href=window.location.href"><i class="fas fa-filter"></i> ' + data.name + '</a>');
                        if ($("#save-filters").length !== false) {
                            $("#save-filters").parent().css('display', 'none');
                        }
                    },
                    error: function (jqXHR, response, errorThrown) {
                        Swal.fire(
                            "Error",
                            response,
                            "error"
                        )
                    }
                });
            }
        });
    }
};

ats.search.use = function (id, url) {
    var csrf = document.querySelector("meta[name=csrf-token]").getAttribute("content");
    $.post('/saved-search/record/' + id, { _token: csrf }, function (response) {
        var separator = url.indexOf('?') === -1 ? '?' : '&';
        $(location).prop('href', url + separator + 'sf=' + id);
    });
};

ats.status = {};
ats.status.OK = 0;
ats.status.ERROR = 500;
ats.status.VALIDATION_ERROR = 400;
ats.status.NOT_FOUND = 404;
ats.status.PERMISSION_DENIED = 401;

ats.modal = {
    show: function (response) {
        $('#' + response.modalId + ' .modal-dialog').removeClass('modal-sm modal-lg modal-xl modal-max').addClass(response.modalSize);
        $('#' + response.modalId + 'Title').html(response.modalTitle);
        if (response.showPopOutButton != 1) {
            $('#' + response.modalId + ' #modal-open-link').hide(0);
        } else {
            $('#' + response.modalId + ' #modal-open-link').show(0);
        }
        if (response.showFooter != 1) {
            $('#' + response.modalId + 'Footer').hide(0);
        } else {
            $('#' + response.modalId + 'Footer').show(0);
        }
        $('#' + response.modalId + 'Body').html(response.content).promise().done(function () {
            $('#' + response.modalId + ' .modal-header #actions-bar').remove();
            $('#' + response.modalId + ' .modal-content').css("padding-top", "64px");
            ats.formElements();
            $('#' + response.modalId + '').modal('show');
        });
    },
    hide: function () {
        $('.modal').modal('hide');
    },
    load: function (url, title, showPopOutButton = 0, size = 'modal-lg', showFooter = 1, showActions = 1) {
        $('#remoteModal .modal-dialog').removeClass('modal-sm modal-lg modal-xl modal-max').addClass(size);
        if (showPopOutButton == 0) {
            $('#modal-open-link').hide(0);
        } else {
            $('#modal-open-link').show(0);
        }
        if (showFooter == 0) {
            $('#remoteModalFooter').hide(0);
        } else {
            $('#remoteModalFooter').show(0);
        }
        $('#remoteModalTitle').html(title);
        $('#modal-open-link').prop('href', url);

        $('#remoteModalBody').load(url, function () {
            $('#remoteModal .modal-header #actions-bar').remove();
            //$('#remoteModal .modal-content').css("padding-top", "64px");
            if (showActions == 1) {
                $('#remoteModalBody #actions-bar').addClass('mt-2').appendTo($('#remoteModal .modal-header'));
                //$('#remoteModal .modal-content').css("padding-top", "100px");
            }
            ats.formElements();
            $('#remoteModal').modal('show');
        });
    },
    post: function (url, formId, reload = 1) {
        $.post(url, $("#" + formId).serialize())
            .done(function (wibble) {
                try {
                    response = JSON.parse(wibble);
                } catch (e) {
                    response = wibble;
                }
                if (response.status == ats.status.VALIDATION_ERROR) {
                    $("#" + formId + " .invalid-feedback").remove();
                    $("#" + formId + " .form-control").removeClass("is-invalid");
                    if (response.validation.length == 1) {
                        $("#alert-" + formId).html('<i class="fas fa-exclamation-circle"></i> ' + response.validation[0].value).removeClass("d-none");
                    } else {
                        var errors = '';
                        for (item in response.validation) {
                            errors = errors + '<li>' + response.validation[item].value + '</li>';
                        }
                        $("#alert-" + formId).html('<i class="fas fa-exclamation-circle"></i> There are ' + response.validation.length + " problems, please review the items below.<ul class=\"mb-0\">" + errors + '</ul>').removeClass("d-none");
                    }
                    $("select + span.select2 span.select2-selection").css('border-color', '#ced4da');
                    $.each(response.validation, function (index, validation_item) {
                        field = validation_item.key;
                        feedback = validation_item.value;
                        //console.log(value);
                        $("#" + formId + " .form-control[name=" + field + "]").addClass("is-invalid");
                        $("select.is-invalid + span.select2 span.select2-selection").css('border-color', '#b20000');
                    });
                    $('.element-scroll-top').animate({ scrollTop: 0 }, 'slow');
                    return false;
                }

                if (response.status == ats.status.OK && reload == 1) {
                    if (typeof response.data != 'undefined' && typeof response.data.redirect_url != 'undefined') {
                        window.location.href = response.data.redirect_url;
                    } else {
                        window.location.reload();
                    }
                    return true;
                } else {
                    $('#remoteModal').modal('hide');
                }
            });
    }
};

ats.shepherd = {
    find: function (token, url) {

        var data = {};
        data._token = token;
        if (url) {
            data.url = url;
        } else {
            data.url = window.location.pathname;
        }
        $.ajax({
            url: "/shepherd-tour",
            type: "POST",
            contentType: "application/json",
            data: JSON.stringify(data),
            cache: false,
            success: function (response) {
                $("body").append(response);
            },
            error: function (jqXHR, response, errorThrown) {
                console.log(response);
            }
        });

    }
};

/* auto-logout */
_ticker = null;
_countdown = null;
ats.ticktock = function (warn, kill) {
    _ticker = setTimeout(function () {
        Swal.fire({
            title: 'Inactive Session',
            html: 'Due to a period of inactivity, your session will be signed out shortly',
            icon: 'warning',
            showCancelButton: true,
            cancelButtonText: 'Sign me out now',
            confirmButtonText: 'I don\'t want to go!'
        }).then((result) => {
            if (result.value) {
                clearTimeout(_countdown);
                ats.ticktock(warn, kill);

            } else {
                ats.logout();
            }
        });
        _countdown = setTimeout(function () {
            ats.logout();
        }, kill * 1000);
    }, warn * 1000);
};

/* logout function */
ats.logout = function () {
    var csrf = document.querySelector("meta[name=csrf-token]").getAttribute("content");
    $.post('/logout', { _token: csrf }, function () {
        window.location.href = '/';
    });
}

/* simple JS templating engine */
ats.curly = function (template, data) {
    var tpl = $('#' + template);
    if (tpl.length) {
        var content = tpl.html();
        var matches = content.match(/\{([\w]+)\}/g);
        for (item in matches) {
            token = matches[item].replace(/\{|\}/g, '');
            content = content.replace('{' + token + '}', data[token]);
        }
        return content;
    } else {
        return "<div>Cannot find Curly template.</div>";
    }
}

/* function to count child elements, and enable a zero count message */
ats.elementCount = function (search, none_msg, min_count = 1) {
    if ($(search).length >= min_count) {
        $(none_msg).addClass('d-none');
    } else {
        $(none_msg).removeClass('d-none');
    }
}

/* open candidate working with panel */
ats.openBatchPanel = function () {
    $('#batchCandidatesContainer').load('/candidate/working-with', function () {
        $('#batchModal').modal('show');
    });
}

ats.follow = function (application_id, first_name) {
    var data = {};
    data._token = token;
    data.application_id = application_id;
    data.name = first_name;
    $.ajax({
        url: "/candidate/follow/" + application_id,
        type: "POST",
        contentType: "application/json",
        data: JSON.stringify(data),
        cache: false,
        success: function (response) {
            ats.alerts.toast("You are now following " + response.candidate_name);
        },
        error: function (jqXHR, response, errorThrown) {
            Swal.fire(
                "Error",
                response,
                "error"
            )
        }
    });
}

ats.unfollow = function (application_id, first_name) {
    var data = {};
    data._token = token;
    data.application_id = application_id;
    data.name = first_name;
    $.ajax({
        url: "/candidate/unfollow/" + application_id,
        type: "POST",
        contentType: "application/json",
        data: JSON.stringify(data),
        cache: false,
        success: function (response) {
            ats.alerts.toast("You are no longer following " + response.candidate_name);
        },
        error: function (jqXHR, response, errorThrown) {
            Swal.fire(
                "Error",
                response,
                "error"
            )
        }
    });
}

ats.addslashes = function (str) {
    // Escapes single quote, double quotes and backslash characters in a string with backslashes
    // Converts potential HTML elements to prevent XSS
    return str
        .replace(/([\\"'])/g, "\\$1")
        .replace(/\0/g, "\\0")
        .replace(/\&/g, '&amp;')
        .replace(/\</g, '&lt;')
        .replace(/\>/g, '&gt;')
        .replace(/\"/g, '&quot;')
        .replace(/\'/g, '&#x27;')
        .replace(/\//g, '&#x2F;');
}

ats.escapeHtmlUsingTextNode = function (unsafe) {
    const div = document.createElement('div');
    div.appendChild(document.createTextNode(unsafe));
    return div.innerHTML;
}

ats.executeScripts = function (selector) {
    let container = document.querySelector(selector);
    if (container) {
        container.querySelectorAll('script').forEach(oldScript => {
            const newScript = document.createElement('script');
            newScript.textContent = oldScript.textContent;
            Array.from(oldScript.attributes).forEach(attr =>
                newScript.setAttribute(attr.name, attr.value)
            );
            oldScript.replaceWith(newScript);
        });
    } else {
        console.error("No element found with selector:", selector);
    }
}

//chartjs4 tooltips
ats.externalTooltipHandler = function (context) {
    // Tooltip Element
    let tooltipEl = document.getElementById('chartjs-tooltip');

    // Create Tooltip Element if Not Existing
    if (!tooltipEl) {
        tooltipEl = document.createElement('div');
        tooltipEl.id = 'chartjs-tooltip';
        tooltipEl.className = 'chartjs-tooltip';
        tooltipEl.style.background = 'rgba(0, 0, 0, 0.7)';
        tooltipEl.style.borderRadius = '3px';
        tooltipEl.style.padding = '5px';
        tooltipEl.style.color = 'white';
        tooltipEl.style.opacity = 1;
        tooltipEl.style.pointerEvents = 'none';
        tooltipEl.style.position = 'absolute';
        tooltipEl.style.transform = 'translate(-0%, 0)';
        tooltipEl.style.transition = 'all .1s ease';
        document.body.appendChild(tooltipEl);
    }

    // Hide tooltip if no active items
    const tooltipModel = context.tooltip;
    if (tooltipModel.opacity === 0) {
        tooltipEl.style.opacity = 0;
        return;
    }

    // Get Tooltip Data
    const datasetLabel = tooltipModel.title[0] || 'Dataset';
    const tooltipData = tooltipModel.body.map(item => item.lines.join('<br>')).join('');

    // Set Tooltip Content
    tooltipEl.innerHTML = `
        <div style="font-weight: bold; margin-bottom: 5px;">${datasetLabel}</div>
        <div>${tooltipData}%</div>
    `;

    // Calculate Position
    const canvas = context.chart.canvas;
    const canvasRect = canvas.getBoundingClientRect();
    tooltipEl.style.opacity = 1;
    tooltipEl.style.position = 'absolute';
    tooltipEl.style.left = canvasRect.left + window.scrollX + tooltipModel.caretX + 10 + 'px';
    tooltipEl.style.top = canvasRect.top + window.scrollY + tooltipModel.caretY + 5 + 'px';
    tooltipEl.style.pointerEvents = 'none';
}


ats.filterList = function (inputId, listId, searchableClasses = []) {
    const input = document.getElementById(inputId);
    const list = document.getElementById(listId);

    input.addEventListener('input', function () {
        const filter = this.value.toLowerCase(); // Get the input value and convert to lowercase
        const listItems = list.querySelectorAll('li'); // Select all <li> elements in the list

        listItems.forEach((item) => {
            let matchesFilter = false;

            // Check each class in the searchableClasses array
            searchableClasses.forEach((className) => {
                const element = item.querySelector(`.${className}`);
                const text = element ? element.textContent.toLowerCase() : '';

                if (text.includes(filter)) {
                    matchesFilter = true; // Mark as matching if any class content includes the filter
                }
            });

            // Show or hide the item based on the match result
            item.style.display = matchesFilter ? '' : 'none';
        });
    });
};

ats.preventMultipleClicks = function (buttonSelector, timeout = 25000, savingText = '<i class="fal fa-spinner fa-spin"></i> Saving...') {
    document.addEventListener('click', function (e) {
        const button = e.target.closest(buttonSelector);

        if (button) {
            // Prevent default click behavior
            e.preventDefault();

            // Check if the button is already disabled
            if (!button.disabled) {
                // Store the original button content
                const originalContent = button.innerHTML;

                // Disable the button and change the content
                button.disabled = true;
                button.innerHTML = savingText;

                // Simulate an asynchronous operation with a timeout
                new Promise((resolve) => {
                    setTimeout(resolve, timeout);
                })
                    .then(() => {
                        // Restore the original content and enable the button
                        button.disabled = false;
                        button.innerHTML = originalContent;
                    })
                    .catch(() => {
                        // Handle errors (optional, though unlikely here)
                        button.disabled = false;
                        button.innerHTML = originalContent;
                    });
            }
        }
    });
}

/* REMOVE IN PRODUCTION */
ats.todo = function (e) {
    ats.alerts.notice('Todo', 'Make this do something');
}
$(document).on('click', '.todo', function (e) {
    console.log("todo button clicked");
    ats.todo();
});
